import { Box, Typography } from "@mui/material";
import { TaskBatch, TaskStatusType } from "../../models/tasks";
import { useNavigate } from "react-router";
import "./BatchItem.scss";

const lungs = require("../../images/lungs.png");
interface BatchItemInterface {
  task: TaskBatch;
  selected: boolean;
  open: boolean;
  reroute?: string;
}

export const BatchItem = ({ task, selected, open, reroute = "/batch?id=" }: BatchItemInterface) => {
  const navigate = useNavigate();

  const completedStatus = task?.completed ? "completed" : task.hasFailedTask ? "failed" : "pending";

  let taskClass = "batchItem";
  if (selected) taskClass += " batchItem-selected";
  if (!open) taskClass += " batchItem-closed";
  if (!task) return null;
  return (
    <div key={task.id} className={taskClass} onClick={() => navigate(reroute + task.id)}>
      <div className="batchItem-left">
        <div className="batchItem-left-icon">
          <img src={lungs} alt="Batch Icon" />
        </div>
        {open && (
          <Box className="batchItem-info">
            <Typography variant={"h4"}>{task.name}</Typography>
            <Typography variant={"subtitle2"} className="batchItem-info-date">
              {new Date(task.createdAt).toLocaleString()}
            </Typography>
          </Box>
        )}
      </div>
      {open && (
        <Box className={"batchItem-info batchItem-info-statusPanel"}>
          <Box className={"batchItem-info-status batchItem-info-status-" + completedStatus}>
            <Typography variant={"caption"}>
              {task.completed ? "COMPLETED" : task.hasFailedTask ? "ERRORS" : "PENDING"}
            </Typography>
          </Box>
          <h1>
            {task.completedTasksNumber} / {task.tasksNumber}
          </h1>
        </Box>
      )}
    </div>
  );
};
